import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Filters from './Filters';
import { withRouter } from 'react-router-dom';
import { capitalizeFirstLetterOfEachWord } from '../../../utils/string';
import enhanceWithClickOutside from '../../../utils/enhanceWithClickOutside';
import classNames from 'classnames';
import './FilterDropDown.scss';

export class _FilterDropDown extends Component {
    static propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                filter: PropTypes.string
            })
        })
    };

    constructor(props) {
        super(props);

        this.openFilterDropDown = this.openFilterDropDown.bind(this);
        this.closeFilterDropDown = this.closeFilterDropDown.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.state = {
            isFiltersDropDownOpen: false
        };
    }

    openFilterDropDown() {
        this.setState({
            isFiltersDropDownOpen: true
        });
    }

    closeFilterDropDown() {
        this.setState({
            isFiltersDropDownOpen: false
        });
    }

    handleClickOutside() {
        if (this.state.isFiltersDropDownOpen) {
            this.closeFilterDropDown();
        }
    }

    render() {
        const containerClassName = classNames('emvio-search-filters-dropdown', {
            'filters-drop-down-open': this.state.isFiltersDropDownOpen
        });

        return (
            <div className={containerClassName}>
                {this.state.isFiltersDropDownOpen
                    ? <Filters onCloseFilterDropDown={this.closeFilterDropDown}/>
                    : <div className="search-filters-select" onClick={this.openFilterDropDown}>
                        <span className="filter-type">
                            {capitalizeFirstLetterOfEachWord(this.props.match.params.filter)}
                        </span>
                        <span className="icon-caret-down" />
                    </div>
                }
            </div>
        );
    }
}

export default withRouter(enhanceWithClickOutside(_FilterDropDown));
